import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'DCO-fallback-error',
  templateUrl: './fallback-error.component.html',
  standalone: false,
})
export class FallbackErrorComponent extends BaseComponent implements OnInit, OnDestroy  {


  private intervalId: any;
  private intervalMilliseconds : number = 10000;

  override ngOnInit(): void {
    super.ngOnInit();

    this.intervalId = setInterval(() => {
      window.location.reload();
    }, this.intervalMilliseconds); // 10 segundos
  }
    ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
